<template>
  <div class="back">

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HowToSaveVector from "../../images/HowToSaveVector.svg";
export default {
  name: "Partners",
  data: () => ({}),
  methods: {
    openChromeStore() {
      window.open(
        "https://chrome.google.com/webstore/detail/dropshop/gemeodelaigfdiekcialemndbakgdicl?hl=en&authuser=2",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.back {
  display: flex;
  width: 100%;
}
</style>
